/**
 *
 * @ngdoc controller
 * @name starter.controller:SearchController
 * @description The controller that takes care of search interactions with the views
 * can search, paginate, support gestures...
 */

import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {isBrowserIE} from '../infra/browserSniffer';
import {Component, Inject, Output, EventEmitter, Input, HostListener} from 'ng-metadata/core';
import {SearchService} from './search.service';
import {SearchFieldsService} from './search.fields.service';
import {
    getDefaultScope,
    isNgrs,
    getScopeList,
    getSuspendWatchersActivatedForBrowser,
    getResultsNumberToDisableSuspendWatchers
} from '../appConfig/appConfigForward';
import {getVid, isShowReasearcherAssistantByWidget} from '../appConfig/appConfigForward';
import {PrimolyticsService, beacon} from '../analytics/primolytics.service';
import {MobileMenu} from './topbar/menu.service';
import {SkipToService} from './topbar/skipTo/skipTo.service';
import {MediaQueries} from '../infra/mediaQueries.service';
import {IAlertMsg} from '../infra/widgets/alerts/alertMsg.interface';
import {AlertFactory, ALERT_MSG_TYPE} from '../infra/widgets/alerts/alertFactory.service';
import {JournalsService} from '../journals/journals.service';
import {preventStateReload} from '../infra/annotations';
import {getAttributesMap, getRefEntryActive} from '../appConfig/appConfigForward';
import {SearchStateService} from "./searchState.service";
import {
    PersonalizeResultsButtonService
} from './personalization/personalizationButton/personalizeResultsButton.service';
import {MappingTablesCache} from '../mappingTablesCache/mappingTablesCache.service';
import {DatabasesService} from "../journals/databases.service";
import {UserSessionManagerService} from '../security/userSessionManager.service';
import {PreFiltersService} from './preFilters/preFilters.service';
import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
import {DatabasesCategorizeService} from "../journals/databasesCategorize/databasesCategorize.service";
import {BriefResultService} from "./briefResult/briefResult.service";
import {OrgListCategorizeService} from '../journals/orgListCategorize/orgListCategorize.service';
import {PagesTitlesService} from "../infra/accessibility/pagesTitles.service";
import {FacetService} from "./facet/facet.service";
import {BarcodeSearchService} from './searchBar/barcodeSearch/barcodeSearch.service';
import {AnalyticsUtils} from '../nddUtils/analyticsUtils.service';
import {NewspapersService} from "../newspapers/newspapers.service";

const isArray = require('lodash/isArray');
const isEmpty = require('lodash/isEmpty');
const memoize = require('lodash/memoize');
const some = require('lodash/some');
const get = require('lodash/get');
const flatten = require('lodash/flatten');
const isEqual = require('lodash/isEqual');
const CITED_BY_FACET_ADDED = ['citedby,exact', 'citing,exact'];

let searchTermObj = {
    query: '-1',
    queryTerm: '-1',
};

@Component({
    selector: 'prm-search',
    templateUrl: 'components/search/search.html'
})

export class PrmSearch {

    private query;
    private borInfoAlert: IAlertMsg;
    private showFacets = false;
    private _showUIBlocker = false;
    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    private showResourceRecommender = false;
    private scope;
    private vid = getVid();
    private showTimer;
    private haveOrgListCategories = true;
    private isConfigJournalCategories: boolean;
    public isReferenceEntry: boolean = true;
    private digestWhenInViewConfigured: boolean;
    private yourSelectedRecordItem: Object;

    private expandedItemIndex = -1;
    private expandedItemHeight: string;
    private listBottomSpacer: boolean = false;

    @HostListener('window:scroll', ['$event']) // for window scroll events
    onScroll(event) {
        this.changeHeightWhenScroll()
    }


    //private terms = ['water', 'water supply handbook','management'];
    //private text = "Water the war supply a war handbook a on war handbook on water supply in war planning and of war resource management a war";
    @Output() private showDialogEvent = new EventEmitter<Object>();
    @Output() private hideDialogEvent = new EventEmitter<Object>();

    constructor(private mobileMenu: MobileMenu,
                private searchService: SearchService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('searchBoxIcons') private searchBoxIcons,
                @Inject('iconSets') private iconSets,
                @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                private searchFieldsService: SearchFieldsService,
                @Inject('$urlRouter') private $urlRouter: ng.ui.IUrlRouterService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
                private primolyticsService: PrimolyticsService,
                private mappingTablesCache: MappingTablesCache,
                private mediaQueries: MediaQueries,
                private skipToService: SkipToService,
                private searchStateService: SearchStateService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private alertService: AlertFactory,
                private journalsService: JournalsService,
                private databasesService: DatabasesService,
                private databasesCategorizeService: DatabasesCategorizeService,
                private personalizeResultsButtonService: PersonalizeResultsButtonService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private userSessionManagerService: UserSessionManagerService,
                private preFiltersService: PreFiltersService,
                private configurationUtil: ConfigurationUtil,
                private briefResultService: BriefResultService,
                private orgListService: OrgListCategorizeService,
                private pagesTitlesService: PagesTitlesService,
                private barcodeSearchService: BarcodeSearchService,
                private facetService: FacetService,
                private analyticsUtils: AnalyticsUtils,
                private newspapersService: NewspapersService) {

        this.searchService.showMobileFacets = true;

        this.searchService.resetSearchDone();
        this.barcodeSearchService.resetBarcodeSearchHasNoResults();
        this.searchStateService.resetSearchObject();
        this.searchService.resetResultObject(); //this is important because the result object is saved on a service which is not reset when switching states
        this.searchService.resetCameFromParams();
        let searchObject = this.searchService.getSearchObject();
        this.digestWhenInViewConfigured = (getSuspendWatchersActivatedForBrowser() === "ALL") || (getSuspendWatchersActivatedForBrowser() === "IE" && isBrowserIE());

        /**
         * @ngdoc property
         * @name query
         * @propertyOf starter.controller:SearchController
         * @description The current query which is run
         */
        if (searchObject) {
            this.query = this.parseSearchTerm(searchObject.query);
            this.scope = searchObject.scope;
        } else {
            this.query = '';
        }


        this.init();

        this.$scope.$watch(() => this.searchInProgress, (newVal) => {
            if (newVal) {
                // this._showUIBlocker= true;
            } else {
                // this.$timeout(()=>{this._showUIBlocker= false}, 0);
                this.$timeout(() => {
                    this.showTimer = true
                }, 0);
            }
        });
        if (angular.element(document).find('prm-full-view').length > 0) {
            //URM-109510 this is to make sure the full view is removed - so that when it opens again it recalculates delivery for services
            this.briefResultService.previousUrl = undefined; //we don't want the md dialog on remove call back to restore the url before we opened the full view
            this.$mdDialog.hide();
        }
        this.isConfigJournalCategories = this.setJournalCategoriesByConfiguration();

        this.updatePagesTitles();

    }

    private updatePagesTitles() {
        let searchQuery = this.searchFieldsService.mainSearch;
        let actionToCode = {
            'exploreMain.npsearch': !this.isSuprima() ? ['nui.mainmenu.label.newspapers_search', '$$QUERY$$'] : ['mainmenu.label.NewspaperSearch', '$$QUERY$$'],
        };

        let titles = {codes: actionToCode[this.$state.current.name], query: searchQuery};
        this.pagesTitlesService.updatePagesTitles(titles);
    }

    private isRecommendationsEnabled() {
        let row = this.mappingTablesCache.findByProperties('Resource Recommender Config', {target: 'enable'});
        return row[0]['source2'] === 'true';
    }

    public hideFacets(): boolean {
        return this.$state.current.name === STATE_NAMES.CITATION_TRAILS;
    }

    private isLoggedInIDP() {
        return this.userSessionManagerService.isLoggedInIDP();
    }

    private containsBrowseGap() {
        return this.searchService.hasBrowseGap();
    }

    private init() {
        this.callResetParametersOfSearchService();
        this.updateFieldsFromUrl();
        if (this.searchService.fromEsploro()) {
            this.updatePageTitleResearch();
            this.updatePageDescriptionResearch();
            this.updateCanonicalFullDisplayResearch();
        } else {
            let searchQuery = this.searchFieldsService.mainSearch;
            let actionToCode = {
                'exploreMain.jsearch': !this.isSuprima() ? ['nui.mainmenu.label.journalsearch', '$$QUERY$$'] : ['mainmenu.label.JournalSearch', '$$QUERY$$'],
                'exploreMain.dbsearch': !this.isSuprima() ? ['nui.mainmenu.label.databasesearch', '$$QUERY$$'] : ['mainmenu.label.DatabaseSearch', '$$QUERY$$'],
            };

            let titles = {codes: actionToCode[this.$state.current.name], query: searchQuery};
            this.pagesTitlesService.updatePagesTitles(titles);
            this.updatePageTitle();
            this.updatePageDescription();
            this.initSelectedRecord();
        }
    }

    public isSuprima() {
        return this.configurationUtil.isSuprima();
    }


    private callResetParametersOfSearchService() {
        let stickyFacetsArray = this.searchService.facetService.getStickyFacets();
        stickyFacetsArray.forEach((facet) => {
            if (facet.persistent) {
                this.searchStickyFacetBeacon(facet);
            }
        });
        if (this.searchService.cameFromState.startsWith('lateralLinking:')) {
            let lateralLinkingValue = '';
            let lateralLinkingArr = this.searchService.cameFromState.split(':');
            if (lateralLinkingArr.length > 1) {
                lateralLinkingValue = lateralLinkingArr[1];
            }
            this.searchService.cameFromState = '';
            this.resetParametersOfSearchServiceWithBeacon(lateralLinkingValue, this.searchService.isFacetExact);
            this.sendAnalytics(this.analyticsUtils.eventsNames.LATERAL_LINKS, {'lateralLinkingValue': lateralLinkingValue});
        } else {
            if (this.$stateParams['came_from']) {
                if (this.$stateParams['came_from'] === 'search_history') {
                    this.resetParametersWithSearchHistoryBeacon();
                } else if (this.$stateParams['came_from'] === 'saved_queries') {
                    this.resetParametersWithSavedQueriesBeacon();
                }
            }
            if (this.hasFacets()) {
                this.resetParametersOfSearchService();
                if (!this.$stateParams['came_from'] && isEmpty(stickyFacetsArray)) {
                    let facets = this.searchStateService.getSearchObject().facets;
                    this.runSearchBeacon();
                    facets.forEach((facet) => {
                        this.doFacetSearch(facet);
                    });
                }
                if (this.$stateParams['came_from'] === 'addFacet') {
                    this.resetCameFromParam();
                }
                if (this.searchService.cameFromState === 'preFilter') {
                    this.runPreFilterBeacon();
                }
            } else if (this.$stateParams['came_from'] && this.$stateParams['came_from'].startsWith('pagination')) {
                this.searchService.cameFromParams.pagination = this.$stateParams['came_from'];
                let fromPage = this.$stateParams['came_from'].split('_')[1];
                let toPage = this.$stateParams['came_from'].split('_')[2];
                if (fromPage < toPage) { // going forward in pages
                    this.resetParametersWithNextPaginationBeacon();
                } else { // going backward in pages
                    this.resetParametersWithPrevPaginationBeacon();
                }

            } else if (this.$stateParams['query'] && !(this.$stateParams['came_from'] === 'search_history' || this.$stateParams['came_from'] === 'saved_queries')) {
                if (this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH) {
                    this.searchJournalsWithBeacon();
                } else if (this.$state.current.name === STATE_NAMES.DB_SEARCH) {
                    this.searchDBWithBeacon();
                } else if (this.$state.current.name === STATE_NAMES.ORGANIZATION_LIST) {
                    this.searchDBWithBeacon();
                } else if (this.$state.current.name === STATE_NAMES.NEWSPAPERS) {
                    this.searchNewspapaersWithBeacon();
                } else if (this.$state.params['mode'] === 'browse') {
                    this.searchBrowseWithBeacon()
                } else if (this.$stateParams['came_from'] === "featuredResults") {
                    this.searchFeaturedResultWithBeacon();
                } else if (this.$stateParams['came_from'] === "personalization") {
                    this.searchPersonalization();
                } else if (this.$stateParams['came_from'] === "sort") {
                    this.searchSort();
                } else if (this.$stateParams['mode'] === 'advanced') {
                    this.searchAdvancedSearchWithBeacon();
                } else {
                    if (this.searchService.cameFromState === 'preFilter') {
                        this.runPreFilterBeacon();
                    }
                    this.searchWithBeacon();
                }
            } else {
                this.resetParametersOfSearchService();
            }

        }
    }


    get isJournalCategories(): boolean {
        return this.databasesCategorizeService.isCategories('journal');
    }

    get isDBCategories(): boolean {
        return this.databasesCategorizeService.isCategories('db');
    }

    get displayDBCategories() {
        return ((this.isDBSearch() && this.isDBCategories)
                || (this.isJournalSearch() && this.isPrimoVE && this.isConfigJournalCategories && this.isJournalCategories))
            && (!this.isSearchFromBarDBorJournals() || this.isSearchFromCategoryTree());
    }

    private isFromRedirectFilter() {
        if (this.$stateParams['fromRedirectFilter'] === 'true') {
            //this.searchService.showAfterRedirectAlert();
            return true;
        } else {
            return false;
        }
    }


    private hasFacets() {
        let facet = this.$stateParams['facet'];
        let multiFacet = this.$stateParams['mfacet'];
        return !(isEmpty(facet) && isEmpty(multiFacet));
    }

    @beacon({'p': 'search', 'op': 'do'})
    private searchWithBeacon() {
        this.sendAnalytics(this.analyticsUtils.eventsNames.SEARCH, {'searchType': 'Basic'});
        this.resetParametersOfSearchService();
    }

    @beacon({'p': 'search', 'op': 'do'})
    private runSearchBeacon() {
        this.sendAnalytics(this.analyticsUtils.eventsNames.SEARCH, {'searchType': 'Basic'});
    }

    @beacon({'p': 'search', 'op': 'atoz'})
    private searchJournalsWithBeacon() {
        this.resetParametersOfSearchService();
    }

    @beacon({'p': 'search', 'op': 'azdb'})
    private searchDBWithBeacon() {
        this.resetParametersOfSearchService();
    }

    @beacon({'p': 'search', 'op': 'newspapers'})
    private searchNewspapaersWithBeacon() {
        this.resetParametersOfSearchService();
        this.$location.search('came_from', null);
    }

    @beacon({'p': 'refine'})
    public doFacetSearch(facet) {
    }

    @preventStateReload
    private resetCameFromParam() {
        this.$location.search('came_from', null);
    }

    @beacon({'p': 'search', 'op': 'browseRelated'})
    private searchBrowseWithBeacon() {
        this.resetParametersOfSearchService();
    }

    @beacon({'p': 'search', 'op': 'featuredResults'})
    private searchFeaturedResultWithBeacon() {
        this.resetParametersOfSearchService();
    }

    @beacon({'p': 'persistent'})
    public searchStickyFacetBeacon(facet) {
    }

    @beacon({'p': 'search', 'op': 'advancedSearch'})
    private searchAdvancedSearchWithBeacon() {
        this.sendAnalytics(this.analyticsUtils.eventsNames.SEARCH, {'searchType': 'Advanced'});
        this.resetParametersOfSearchService();
    }

    @beacon({'p': 'search', 'op': 'preFilter'})
    public runPreFilterBeacon() {
        this.sendAnalytics(this.analyticsUtils.eventsNames.SEARCH, {'searchType': 'Filter Bar'});
    }

    @preventStateReload
    private searchPersonalization() {
        this.resetParametersOfSearchService();
        this.$location.search('came_from', null);
    }

    @preventStateReload
    private searchSort() {
        this.resetParametersOfSearchService();
        this.$location.search('came_from', null);
    }


    private setShowResourceRecommender(show) {
        this.showResourceRecommender = show;
    }

    private resetParametersOfSearchService() {
        let res = this.searchService.resetParameters();
        if (res && res.then) {
            res.then(() => {
                this.$timeout(() => this.showFacets = true, 1000);
                if (this.$state.current.name === STATE_NAMES.CITATION_TRAILS) {
                    this.focusOnFirstPage();
                }
            });
        }
    }

    /*
    A Beacon call after a search history query was invoked.
    The search service Beacon call is not being called.
    Coming from search history, was indicated by adding a state param to the url, that will be deleted here.
    */
    @preventStateReload
    @beacon({'p': 'search', 'op': 'sessionQuery'})
    private resetParametersWithSearchHistoryBeacon() {
        this.$location.search('came_from', null);
        //this.resetParametersOfSearchService();
    }

    /*
    A Beacon call after a saved queries query was invoked.
    The search service Beacon call is not being called.
    Coming from saved queries, was indicated by adding a state param to the url, that will be deleted here.
    */
    @preventStateReload
    @beacon({'p': 'search', 'op': 'savedQuery'})
    private resetParametersWithSavedQueriesBeacon() {
        this.$location.search('came_from', null);
        //this.resetParametersOfSearchService();
    }


    @preventStateReload
    @beacon({'p': 'brief', 'op': 'next'})
    private resetParametersWithNextPaginationBeacon() {
        this.$location.search('came_from', null);
        this.resetParametersOfSearchService();
    }

    @preventStateReload
    @beacon({'p': 'brief', 'op': 'previous'})
    private resetParametersWithPrevPaginationBeacon() {
        this.$location.search('came_from', null);
        this.resetParametersOfSearchService();
    }

    private focusOnFirstPage() {
        this.$timeout(() => {
            let pageElement = document.querySelector('#searchResultPage1');
            if (pageElement) {
                pageElement.setAttribute('tabindex', '-1');
                pageElement.focus();
                pageElement.setAttribute('tabindex', '0');
            }
        }, 0);

    }

    @beacon({'p': 'search', 'op': 'lateralLinking'})
    private resetParametersOfSearchServiceWithBeacon(lateralLinkingValue, isFacetExact) {
        this.resetParametersOfSearchService();

    }

    private async sendAnalytics(eventName, parameters) {
        let payload = {};
        switch (eventName) {
            case this.analyticsUtils.eventsNames.LATERAL_LINKS:
                payload = await this.getAnalyticsPayload(parameters.lateralLinkingValue);
                this.analyticsUtils.trackUsage(eventName, payload);
                break;
            case this.analyticsUtils.eventsNames.SEARCH:
                let unregisterWatch = this.$rootScope.$watch(() => {
                        return this.searchService.isSearchInProgress();
                    },
                    (newVal, oldVal) => {
                        if (newVal === false && oldVal === true) {
                            this.searchService.sendAnalytics(parameters.searchType);
                            unregisterWatch();
                        }
                    });
                break;
        }

    }

    private async getAnalyticsPayload(lateralLinkingValue) {
        let fieldVal = isEqual('sub', lateralLinkingValue) ? 'subject' : lateralLinkingValue;
        let fieldName = await this.$translate('fulldisplay.' + fieldVal.trim());

        return {
            'Field': this.searchService.capitalizeFirstLetter(fieldVal.trim()),
            'Field Name': this.searchService.capitalizeFirstLetter(fieldName),
            'Field Value': this.searchService.capitalizeFirstLetter(this.getSearchTermsFromUrl().trim()),
            'Resource Type': this.searchService.lateralLinkingRecordType,
            'Record ID': this.searchService.lateralLinkingRecordID,
            'Record Title': this.searchService.lateralLinkingRecordTitle
        }
    }


    private getSearchTermsFromUrl() {
        let searchTerm = this.getParamFromQuery(2);
        return searchTerm.length > 0 ? searchTerm[0] : '';
    }

    private getParamFromQuery(i) {
        let queries = this.$stateParams['query'];
        if (queries) {
            queries = flatten([queries]);
            let param = queries.map((query) => {
                //arr contains elements from type 'any,contains,a,AND'
                let arr = query.split(',');
                if (i === 2) { // handling search term parameter
                    if (this.$stateParams['mode'] === 'advanced') {
                        if (arr.length > 4) { //advanced search and there was a comma in the query
                            return arr.slice(2, -1).join(",");
                        }
                    } else if (arr.length > 3) { //simple search and there was a comma in the query
                        return arr.slice(2).join(",");
                    }
                }
                return arr[i];
            });
            return param;
        }
    }

    private isLinksMenuVisible() {
        return this.mobileMenu.getLinksMenuVisible();
    }


    /* tslint:enable:no-unused-variable*/

    public onSearchBarSearchEvent(eventData) {
        let stateName = STATE_NAMES.SEARCH;
        if (this.journalsService.isJournalSearch() || this.journalsService.returnToJournalsSearch()) {
            stateName = STATE_NAMES.JOURNAL_SEARCH;
        }
        if (this.databasesService.isDBSearch()) {
            stateName = STATE_NAMES.DB_SEARCH;
        }
        if (this.orgListService.isOrgListSearch()) {
            stateName = STATE_NAMES.ORGANIZATION_LIST;
        }

        let params = {
            search_scope: eventData.scopeField,
            tab: eventData.tab,
            journals: eventData.journals,
            databases: eventData.databases,
            organization: eventData.organization,
            organizationPath: eventData.organizationPath,
            sortby: eventData.sortby,
            query: 'contains,' + eventData.searchType + ',',
            vid: this.vid,
            facet: []

        };
        if (angular.isDefined(eventData.offset)) {
            params.offset = eventData.offset;
        }
        this.$state.go(stateName, params, {reload: stateName});

    }


    private isSearchDone() {
        return this.searchService.isSearchDone();
    }

    private isBarcodeSearchHasNoResults() {
        return this.barcodeSearchService.isBarcodeSearchHasNoResults();
    }

    public isBarcodeSearchTabSelected() {
        return this.$location.search().searchType === 'barcode';
    }

    public getNoResultsBarcodeSearchTerm() {
        return this.barcodeSearchService.noResultsBarcodeSearchTerm;
    }

    public isBarcodeSearchInProgress() {
        return this.barcodeSearchService.barcodeSearchInProgress;
    }

    private hasSearchResults(): boolean {
        let res = this.searchResults;
        return isArray(res) && res.length > 0;
    }

    private get searchResults() {
        return this.searchService.getResultObject().data;
    }

    private get featuredResult() {
        return this.searchService.getResultObject().featuredResult;
    }

    private updatePageTitle() {
        this.searchService.updatePageTitle();
    }

    private updatePageDescription() {
        this.searchService.updatePageDescription();

    }

    private updatePageTitleResearch() {
        this.searchService.updatePageTitleResearch();
    }

    private updatePageDescriptionResearch() {
        this.searchService.updatePageDescriptionResearch();
    }

    private updateCanonicalFullDisplayResearch() {
        this.searchService.updateCanonicalFullDisplayResearch();
    }

    private parseSearchTerm(query) {
        if (!query) {
            return '';
        }
        query = this.preFiltersService.removePreFilter(query, false, ';');
        if (searchTermObj.query === query) {
            return searchTermObj.queryTerm;
        }

        if (this.isBrowseMode && query.startsWith("Browse:")) {
            query = query.replace("Browse: ", ",,");
        }

        let queryArray = query.split(',');
        /* remove field - first element in array
         * remove operator - second element in array
         * We only need the value
         *
         * e.g
         * any,contains,water -> water
         * creator,exact,John -> John
         */
        for (let i = 0; i < 2; i++) {
            queryArray.shift();
        }
        searchTermObj.query = query;
        let queryTerm = queryArray.join(',');
        searchTermObj.queryTerm = queryTerm;
        return queryTerm;
    }

    private updateFieldsFromUrl() {
        let searchObject = this.searchService.getSearchObject();
        this.searchFieldsService.searchParams = this.$location.search();
        if (this.$stateParams['mode'] !== 'advanced') {
            if (searchObject) {
                this.searchFieldsService.mainSearch = this.parseSearchTerm(searchObject.query);
            }

        }

        searchObject = searchObject || {};
        this.searchFieldsService.scope = searchObject.scope || getDefaultScope();
        this.searchFieldsService.sortby = searchObject.sortby || 'rank';
        this.searchFieldsService.offset = searchObject.offset || 0;


        //this.searchFieldsService.facets= this.searchService.getSearchObject().facets;
    }

    get signInAlert(): IAlertMsg {
        return this.searchService.signInAlert;
    }

    get browseGapAlert(): IAlertMsg {
        return this.searchService.browseGapAlert;
    }

    get afterRedirectAlert(): IAlertMsg {
        return this.searchService.afterRedirectAlert;
    }

    get skipLinks() {
        if (this.skipToService.skipLinks) {
            return this.skipToService.skipLinks.search;
        }
        return undefined;
    }

    get highlights() {
        return this.searchService.highlightsService.highlights;
    }

    public isShowPartsOnCitationTrails() {
        let state = this.$state.current.name;
        const facets = this.$stateParams['facet'];
        let checkForCitedBy = facet => facet !== undefined && CITED_BY_FACET_ADDED.some((citedByPrefix => facet.startsWith(citedByPrefix)));
        let citedByFacetExists = isArray(facets) ? facets.some(checkForCitedBy) : checkForCitedBy(facets);
        return state === STATE_NAMES.CITATION_TRAILS || citedByFacetExists;
    }

    get isAtozSearch() {
        return this.journalsService.isJournalSearch() || this.databasesService.isDBSearch();
    }

    public isDBSearch() {
        return this.databasesService.isDBSearch();
    }

    get isDBcategory() {
        return this.$stateParams['query'].indexOf('contains,dbcategory') !== -1;
    }

    get isBrowseMode() {
        return this.$stateParams['mode'] === 'browse';
    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        let isJouralCategoriesEnabled = get(getAttributesMap(), ['journalCategoriesTree'], false);

        if (this.isDBSearch()) {
            return true;
        }

        if ((this.isJournalSearch() && this.isPrimoVE && this.isJournalCategories) &&
            this.isSearchFromBarDBorJournals() && isJouralCategoriesEnabled) {
            return true;
        }
        if (this.isOrgListSearch() && this.haveOrgListCategories) {
            return true;
        }
        return viewConfig['selectedFacetLocation'] === 'left';
    }

    get isPrimoVE() {
        return this.configurationUtil.getBackendSystem() === 'suprima';
    }

    public displayDialog() {
        return this.personalizeResultsButtonService.displayDialog();
    }

    private get searchInProgress() {
        return this.searchService.isSearchInProgress();
    }

    private get showUIBlocker() {
        return this._showUIBlocker;
    }

    public cancel(e) {
        this.personalizeResultsButtonService.cancelPressed = true;
    }

    private keydownSupport(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === 27) {
            this.cancel(e);
        }
    }

    public keydownSupportPersonalization(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === 27) {
            this.cancel(e);
            this.$timeout(() => {
                return document.querySelector('#personalizationBtn').focus();
            }, 100);
        }
    }

    private closeMobileFacet($event) {
        this.showMobileFacets = true;
    }

    get showMobileFacets(): boolean {
        return this.searchService.showMobileFacets;
    }

    set showMobileFacets(value: boolean) {
        this.searchService.showMobileFacets = value;
    }

    // Indication if you are on "PC" scope
    public showPcAvailabilityForScope = memoize(() => {
        let map = window.appConfig['primo-view']['pc-availability-tab-scopes-map'];
        let scope = this.$stateParams['search_scope'];
        return some(Object.keys(map), (value) => map[value][scope] === 'AVAILABLE_ONLY');
    });

    // Indication if you are on "PC" scope ("Include Results with no full-text" flag can be on or off)
    public showPcAvailabilityForScopeWithNFT = memoize(() => {
        let map = window.appConfig['primo-view']['pc-availability-tab-scopes-map'];
        let scope = this.$stateParams['search_scope'];
        return some(Object.keys(map), (value) => map[value][scope] === 'AVAILABLE_ONLY' || map[value][scope] === 'INCLUDE_NO_FULL_TEXT');
    });

    public hideReferenceEntryItem(event) {
        this.isReferenceEntry = false;
    }

    private get searchInfo() {
        return this.searchService.getResultObject().info;
    }

    public isSearchFromBarDBorJournals() {
        return this.databasesCategorizeService.isSearchFromBarDBorJournals();
    }

    public isSearchFromLetters() {
        return this.databasesCategorizeService.isSearchFromLetters();
    }

    public isSearchFromCategoryTree() {
        return this.databasesCategorizeService.isSearchFromCategoryTree();
    }

    public refEntryActive() {
        return getRefEntryActive();
    }

    private isCitationState() {
        return this.$state.current.name === STATE_NAMES.CITATION_TRAILS;
    }

    private isChaptersAndReviewsState() {
        return (this.$state.current.name == STATE_NAMES.CITATION_CHAPTERS || this.$state.current.name == STATE_NAMES.CITATION_REVIEWS)
    }

    get isMobileDBSlider() {
        return this.databasesCategorizeService.isMobileDBSlider;
    }

    public openMobileDBSlider() {
        this.databasesCategorizeService.isMobileDBSlider = true;
        document.body.style.overflow = 'hidden';
        /*document.body.style.pointerEvents = 'none';*/
    }

    public openMobileOrgCategoriesSlider() {
        this.orgListService.isMobileDBSlider = true;
        document.body.style.overflow = 'hidden';
    }

    get isMobileOrgCategoriesSlider() {
        return this.orgListService.isMobileDBSlider;
    }

    public isOrgListSearch() {
        return this.orgListService.isOrgListSearch();
    }

    public setHaveOrgListCategories(haveOrgListCategories) {
        this.haveOrgListCategories = haveOrgListCategories;
    }

    public isSearchFromOrgListCategory() {
        return this.orgListService.isSearchFromOrgListCategory();
    }

    public isJournalSearch() {
        return this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH;
    }

    public getCategoriesType() {
        if (this.isDBSearch())
            return "db";
        if (this.isJournalSearch())
            return "journal";
        if (this.isSearchFromOrgListCategory())
            return "orgList";
        else
            return "";
    }

    private getCategoriesCode(code: string) {
        if (this.getCategoriesType() == 'db')
            return 'dbcategories.' + code;
        if (this.getCategoriesType() == 'journal') {
            if (code == 'databases')
                code = 'journals';
            return 'nui.journalsearch.category.' + code;
        }
        return code;
    }

    private setJournalCategoriesByConfiguration() {
        return get(getAttributesMap(), ['journalCategoriesTree'], true);
    }

    private showRapidoResultsButton() {
        if (isNgrs()) {
            let scopeOptions = getScopeList();
            for (let i = 0; i < scopeOptions.length; i++) {
                if (scopeOptions[i]["contains-central-index-scope"] === true) {
                    let scopeTab = scopeOptions[i]["tab"];
                    let searchProfileCode = scopeOptions[i]["scope-id"];
                    let availableOnly = window.appConfig['primo-view']['pc-availability-tab-scopes-map'][scopeTab][searchProfileCode];
                    if (availableOnly !== 'AVAILABLE_ONLY') {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    private hideDialog() {
        if (this.digestWhenInViewConfigured) {
            this.hideDialogEvent.emit({});
        }
        this.handleZoteroClass();

    }

    private showDialog() {
        if (this.digestWhenInViewConfigured) {
            this.showDialogEvent.emit({});
        }
        this.handleZoteroClass();

    }

    public isListOfVersion() {
        return this.facetService.isFrbrSearch();
    }

    public backToSearchResults() {
        let currActiveFacets = this.searchService.activeFacets;
        let frbr = currActiveFacets ? currActiveFacets.find(obj => obj.name === 'frbrgroupid') : null;
        if (frbr) {
            this.searchService.clearListOfVersion(frbr);
        }
        sessionStorage.removeItem(this.searchService.YOUR_SELECTED_RECORD_ITEM);
    }

    public handleZoteroClass() {
        let zoteroElements = document.getElementById('zoteroSingleRecord');
        if (zoteroElements && zoteroElements.className) {
            zoteroElements.className = (zoteroElements.className === 'closed') ? 'urlToXmlPnxSingleRecord' : 'closed';
        }
    }

    private initSelectedRecord() {
        let selectedRecordItemFromStorage = sessionStorage.getItem(this.searchService.YOUR_SELECTED_RECORD_ITEM);
        this.yourSelectedRecordItem = selectedRecordItemFromStorage ? JSON.parse(selectedRecordItemFromStorage) : false;
    }

    public getYourSelectedRecordItem() {
        return this.yourSelectedRecordItem;
    }

    get isHighlightTheRecordYouCameFromEnabled() {
        return this.searchService.isHighlightTheRecordYouCameFromEnabled();
    }

    get isHighlightTheRecordYouCameFromFeatureFlagActive() {
        return this.searchService.isHighlightTheRecordYouCameFromFeatureFlagActive();
    }


    private isExpanded(index) {
        return this.expandedItemIndex === index;
    }

    private setExpandedItem($event, index) {
        if ($event.expand) {
            this.expandedItemHeight = $event.target.parentNode.offsetHeight + 'px';
            this.expandedItemIndex = index;
            this.toggleListBottomSpacer(true);
        } else {
            this.expandedItemHeight = '';
            this.expandedItemIndex = -1;
            this.toggleListBottomSpacer(false);
        }
    }

    private toggleListBottomSpacer(bool) {
        this.listBottomSpacer = bool
    }

    private selectedItemHeight() {
        this.expandedItemHeight;
    }

    get disableDigest() {
        return this.isDigestWhenInViewDisabled || this.isExpanded;
    }

    get isDigestWhenInViewDisabled() {
        return 1 <= getResultsNumberToDisableSuspendWatchers();
    }

    public isShowCitationTrailExpandButtonNoResults() {
        let isClassicPrimo = !this.isSuprima();
        let isPrimoVeWithFeatureFlagOn = this.configurationUtil.getFeatureFlag("configuration_to_use_filtered_or_expand_search_for_citation_trail");
        return this.isCitationState() && !this.searchInProgress && this.searchInfo && this.searchInfo.total == 0 && !this.hasSearchResults() && (isClassicPrimo || isPrimoVeWithFeatureFlagOn);
    }

    get showRASideBar() {
        return isShowReasearcherAssistantByWidget() && !this.searchInProgress;
    }

    public researchAssistantToggleButton() {
        const toggleRaButton = document.getElementById('toggleRaButton');
        const toggleRaWidgetCont = document.getElementById('toggleRaWidgetCont');

        toggleRaWidgetCont.classList.toggle('open');
        toggleRaButton.style.display = 'none'; // Hide toggleRaButton when toggleRaWidgetCont is open
        toggleRaWidgetCont.setAttribute('aria-hidden', 'false');
        toggleRaButton.setAttribute('aria-expanded', 'true');
        toggleRaWidgetCont.focus();
    }

    private changeHeightWhenScroll() {
        const raContainer = document.getElementById('raContainer');
        const self = this; // Store the reference to the PrmSearch instance
        if (raContainer) {
            window.addEventListener('scroll', function () {
                if (window.scrollY > 100) { // scroll value
                    if (self.facetToLeft && self.mediaQueries.md) {
                        raContainer.style.top = '130px';
                    } else  {
                        raContainer.style.top = '80px';
                    }
                } else {
                    raContainer.style.top = 'auto';
                }
            });
        }
    }
    private get isNewspapersSearch() {
        return this.newspapersService.isNewspapersSearch();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/search.directive.ts